import { defineNuxtRouteMiddleware, navigateTo } from "#app";
import { useNuxtAuth } from "@kopf3/adapt-oidc-component";

export default defineNuxtRouteMiddleware(async to => {
    if (import.meta.server) return;

    const auth = useNuxtAuth();

    const publicRoutes = new Set<string>(["/login", "/callback"]);
    const isPublic = publicRoutes.has(to.path);

    if (to.path === "/") {
        if (auth.isAuthenticated.value) {
            return navigateTo("/maintenance-planner");
        }
        return;
    }

    if (!isPublic && !auth.isAuthenticated.value) {
        await auth.login();
        return;
    }
});
